class SITE {

    constructor() {}

    // SINGLETON
    static init() {

        const modules = [Global, Prod, YT_video];

        if (typeof window._SITE == 'undefined') {

            window._SITE = {_this: new this()};
            modules.forEach((_class) => {

                const this_class = new _class();
                window._SITE[this_class.constructor.name] = this_class;

            });

        }

        return window._SITE;

    }
}

class Prod extends SITE {

    selectors = {

        product_select_container: '.product-variant-option',
        addon_select_container: '.addon-product-container',

    };

    product = {

        main: {},
        addon: [],

    };

    constructor() {

        super();

        if (!location.href.includes('/products/')) { return; }

        // set main product
        this.product.main = JSON.parse($('[id*="product-json"]').html());

        let json = null;

        $(this.selectors.addon_select_container+' script[type="application/json"]').each((k, script) => {

            var json = JSON.parse(script.innerHTML);
            json ? this.product.addon.push(json) : null;

        });

        this.reg_events();

        $('.prod-page-tabs button[data-tab-target]').on('click', (e) => {

            let $this = $(e.currentTarget);
            let $container = $this.closest('.prod-page-tabs');

            const h_active = 'tab-title--active';
            const c_active = 'tab-content--active';

            if (!$this.is('.' + h_active)) {

                $container.find('.' + h_active).removeClass(h_active);
                $this.addClass(h_active);

                $container.find('.' + c_active).removeClass(c_active);
                $container.find('[data-tab-index="' + $this.data('tab-target') + '"]').addClass(c_active);

            }

        }).first().click();

    }

    get all() {

        return [this.product.main].concat(
            this.product.addon,
        );

    }

    get main_variant() {

        const $selected_val = $('input[name="id"]').val();
        return this.product.main.variants.filter(i => i.id == $selected_val)[0];

        // ---------------------------------------------------------------

        var variant_name = [];
        $(this.selectors.product_select_container+' select').each(function () {

            variant_name.push($(this).val());

        });

        if (variant_name[0]) {

            return this.#get_by_name(variant_name.join(' / '), this.product.main);

        } else {

            return this.product.main.variants[0];

        }

    }

    get_addon_variant($container = null, scope) {

        scope = typeof scope != 'undefined' ? scope : this.addon;

        var variant_name = [];
        $container.find('select').each(function () {

            variant_name.push($(this).val());

        });

        return this.#get_by_name(variant_name.join(' / '), scope);

    }

    get find() {

        return {

            id: this.#get_by_id.bind(this),
            handle: this.#get_by_handle.bind(this),
            sku: this.#get_by_sku.bind(this),
            name: this.#get_by_name.bind(this),

        };

    }

    #get_by_id(id = '', scope) {

        scope = typeof scope != 'object' ? this.all : scope;
        scope = Array.isArray(scope) ? scope : [scope];
        let item = null;

        scope.forEach((p) => {

            if (typeof p == 'undefined' || p == null || Object.keys(p).length == 0) { return; }

            if (p.id == id) {

                item = p;

            } else {

                p.variants.forEach((v) => {
                    if (v.id == id) {
                        item = v;
                        item.product = p;
                    }
                });

            }

        });

        return item;

    }

    #get_by_handle(handle = '', scope) {

        scope = typeof scope != 'object' ? this.all : scope;
        scope = Array.isArray(scope) ? scope : [scope];
        let item = null;

        scope.forEach((p) => {

            if (typeof p == 'undefined' || p == null || Object.keys(p).length == 0) { return; }

            if (p.handle == handle) {

                item = p;
                item.product = p;

            }

        });

        return item;

    }

    #get_by_sku(sku = '', scope) {

        scope = typeof scope != 'object' ? this.all : scope;
        scope = Array.isArray(scope) ? scope : [scope];
        let item = null;

        scope.forEach((p) => {

            if (typeof p == 'undefined' || p == null || Object.keys(p).length == 0) { return; }

            p.variants.forEach((v) => {
                if (v.sku == sku) {
                    item = v;
                    item.product = p;
                }
            });

        });

        return item;

    }

    #get_by_name(name = '', scope) {

        scope = typeof scope != 'object' ? this.all : scope;
        scope = Array.isArray(scope) ? scope : [scope];
        let item = null;

        scope.forEach((p) => {

            if (typeof p == 'undefined' || p == null || Object.keys(p).length == 0) { return; }

            if (p.title == name) {

                item = p;

            } else {

                p.variants.forEach((v) => {
                    if (v.public_title == name || v.id == name || v.title == name) {
                        item = v;
                        item.product = p;
                    }
                });

            }

        });

        return item;

    }

    reg_events() {

        $('input[name="id"]').on('change', (e) => {

            $('.product__title > span').text(_SITE.Prod.main_variant.sku );

        });

    }

}

class Global extends SITE {

    constructor() {

        super();

        this.toogle_header_cta();

    }

    toogle_header_cta() {

        $('.contact--dropdown').on('click', (e) => { e.stopPropagation(); });

        $('.button--contact').click((e) => {
            
            e.preventDefault();
            e.stopPropagation();
            let $this = $(e.currentTarget);
            let $dropdown = $('.contact--dropdown')

            $this.toggleClass('active');
            $dropdown.toggle();

            $('body').one('click', () => {

                $this.toggleClass('active');
                $dropdown.toggle();

            });

        });

    }

}

class YT_video extends SITE {
    constructor() {
        super();
        
        this.resize_video();

        window.addEventListener('resize', this.resize_video);
        document.querySelector('[data-tab-target="tab-video"]').addEventListener('click', this.resize_video);

    }

    resize_video() {
            document.querySelectorAll('iframe.js-youtube').forEach((iframe) => {
                /* set the video height ratio relative to the width */
                const ratio = 9/16; // --> 9:16 ratio
                iframe.style.height = (iframe.clientWidth * ratio) + 'px';
            });
    }
} 

window.addEventListener('DOMContentLoaded', (event) => { SITE.init(); });